<template>
  <div>
    <div v-if="!isInvalid" :class="readingStyle" padding>
      <h1 class="digest-title" @click="info()">
        {{this.digest.title || this.doc.shortTitle}}
        <span><ion-icon name="information-circle-outline"></ion-icon></span>
      </h1>
      <div v-if="$route.query.u" class="digest-subinfo">
        <div style="margin-right: 0.5em; padding-top: 0.3em;"><ion-icon style="margin-right: 0.2em;" name="contact"></ion-icon><span v-if="author">{{author}}</span></div>    
      </div>
      <div v-else class="digest-subinfo">
        <div style="margin-right: 0.5em; padding-top: 0.3em;"><ion-icon style="margin-right: 0.2em;" name="contact"></ion-icon><span>Me</span></div>    
      </div>
      <hr class="title-hr" />
      <div ref="rendered" v-html="rendered" class="rendered allow-select"></div>
    </div>

    <div v-else class="notebook-notice">
      <h6>
        Digest not found or invalid url.
      </h6>
    </div>

    <div v-if="popupContent">
      <div id="popupMenu" style="display:none">
        <popup-menu></popup-menu>
      </div>
    </div>

    <div v-if="!isPublic">
      <div v-if="digest.notes || isEditable" style="padding: 0 16px;">
        <hr/>
      </div>

      <div v-if="digest.notes || isEditable" ref="digest-notes" style="padding: 0 16px 8px 16px; display: flex; align-items: center; width: 100%">
        <h3 style="margin: 0">Notes</h3>
        <div style="flex-grow: 1;"></div>
        <div style="margin-right: 0;">
          <ion-button size="small" v-if="isEditable" @click="save">Save</ion-button>
          <ion-button size="small" v-else @click="isEditable = true">Edit</ion-button>
        </div>
      </div>
      <div v-else-if="!digest.notes && !isEditable" ref="digest-notes" style="text-align: center; width: 100%; padding-top: 2em;">
        <ion-button @click="isEditable = true"> <ion-icon style="margin-right: 8px;" name="create"></ion-icon> Add Notes</ion-button>
      </div>
      <tiptap v-if="isEditable" v-model="digest.notes"/>
      <div v-else-if="digest.notes && !isEditable" :class="readingStyle" v-html="digest.notes" padding></div>
    </div>

  </div>
</template>
<script>
import Tiptap from '../../components/Editor.vue';
import Menu from "./PopupMenu";

export default {
  data() {
    return {
      popupContent: false,
      id: "",
      digest: {
        title: "",
        content: "",
        meta: {},
        notes: ""
      },
      content: "",
      doc: {},
      docId: "",
      docType: "",
      showComments: true,
      isEditable: false,
      isPublic: false,
      author: "",
      isInvalid: false
    };
  },

  methods: {
    async load(id) {
      this.id = id;

      if (id) {
        if(id.startsWith("c")) {
          this.isPublic = true;
          const docid = id.substring(1);
          this.docId = docid;
          await this.loadDocInfo(docid, "case");
         if(this.$route.query.u) {
            var decodedString = atob(this.$route.query.u);
            const e = decodedString.split("|");
            this.author = e[1];
            await this.generateDigestFromAnnotations(e[0]);
            return;
         }
         await this.generateDigestFromAnnotations();
        } else {
          var res = await this.$lawyerly.digests.view({
            id: id
          });
          if (res.data && res.data.count) {
            var note = res.data.result[0];
            this.digest = note;
            this.docId = note.docid;

            await this.loadDocInfo(note.docid, note.doctype);

            // if (!this.content) {
            //   this.$router.replace("/digests/edit/" + this.id);
            //   return;
            // }

            await this.generateDigestFromAnnotations();

            this.meta = note.meta;
            // setTimeout(() => {
            //   this.$root.morphLinks(this.$refs.rendered);
            // }, 500);
            this.$root.mountPrintable(this.digest.title, this.rendered, 'Digest');
          }
        }
      }
    },

    edit() {
      this.$router.push("/digests/edit/" + this.id);
    },

    more(evt) {
      this.popupContent = false; // re-create always
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(evt, {
          template: "popupMenu",
          translucent: true
        });
      }, 200);
    },

    onHeaderCommand(event, cmd) {
      switch (cmd.cmd) {
        case "info":
          this.open()
          break;
        case "more":
          this.more(event);
          break;
        case "notes":
          this.scrollToNotes();
          break;
        case "comments":
          this.toggleComments();
          break;
        case "refresh":
          this.refresh();
          break;
        case "share":
          this.share();
          break;
      }
    },

    async loadDocInfo(id, type) {
      var doc = await this.$lawyerly[type+"s"].view({ id: id });
      if(doc.data) {
        if(Object.keys(doc.data).length > 0) {
          delete doc.data.content;
          doc.data.type=type;
          this.doc = doc.data;
          this.docType = type;          
        }
      }
    },

    async refresh() {
      await this.$ionic.showLoading("Generating digest...");

      await this.generateDigestFromAnnotations(this.docId);

      setTimeout(()=>{
        this.$ionic.dismissLoading();
      }, 500);

    },

    async generateDigestFromAnnotations(email = null) {

      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(email) {
        if(!regex.test(email.toLowerCase())) {
          this.isInvalid = true;
          return;
        }
      }

      let doc = {
        docId: this.docId,
        typeId: 1,
        digest: 1
      };

      if(email) {
        doc['email'] = email;
      }

      var res = await this.$lawyerly.annotations.search(doc);

      if(res) {
        if(res.data.length > 0) {
          this.content = this.$lawyerly.annotations.digest({
            annotations: res.data
          });
           this.initiateMenu();
           return;
        }
      }

      this.isInvalid = true;
    },

    async save(refresh = false) {
      // if (!this.doc.title) {
      //   this.$ionic.showToast("Please provide a title.", {
      //     position: "bottom"
      //   });
      //   return;
      // }

      var data = this.digest;
      data.tags = [];
      data.category = [];

      var res = {};

      if (!this.id) {
        // digests are server created
        // res = await this.$lawyerly.digests.create(data);
        // if (res.data && res.data.id) {
        //   this.id = res.data.id;
        //   this.$router.replace("/digests/edit/" + this.id);
        // }
      } else {
        data.id = this.id;
        // update
        res = await this.$lawyerly.digests.update(data);
      }

      if (res.data && res.data.id) {
        this.$ionic.showToast("Saved.", {
          position: "bottom"
        });
        this.isEditable = false;
      } else {
        this.$ionic.showToast("Unable to save.", {
          position: "bottom"
        });
      }
    },

    async info() {
      this.$ionic.dismissPopover();
          await this.$ionic.showAlert(`<div style="text-align: center;">
          <h4>${this.doc.title}</h4>
          <h6>[${this.doc.shortGR}, ${this.doc.date}]</h6>
          <h6>${this.doc.ponente}</h6>
          </div>`,
          {
            cssClass: "medium-width-alert",
            header: "Source",
            buttons: [
              {text: "View Case", handler: () => { this.open(); return true;}},
              "Close"
            ]
          }
        );
      },

    open() {
      this.$router.push(`/cases/${this.docId}`);
      this.$ionic.dismissPopover();
    },

    toggleComments(noheight = false) {
      
      if(!noheight) {
        this.$store.commit("ui/editMoreHeaderButtons", {
          idx: 1,
          field: 'icon',
          data:  `${this.$store.state.ui.moreHeaderButtons.web[1]['icon'] === 'eye' ? 'eye-off' : 'eye'}`
        });
      }
      
      document.querySelectorAll('.digest-content i').forEach(el => {
        const ch = el.clientHeight,
          sh = el.scrollHeight,
          isCollapsed = !ch,
          noHeightSet = !el.style.height;

        el.style.height = (isCollapsed || noHeightSet ? sh : 0) + "px";
        if (noHeightSet) return this.toggleComments(true);
      });
    },

    scrollToNotes() {
      if(!this.isEditable && !this.digest.notes) {
        this.isEditable = true;
      }
      setTimeout(()=>{
        this.$refs["digest-notes"].scrollIntoView({
          block: 'start',
          behavior: "smooth"
        });
      }, 300);
    },
    async share() {
      var encodedString = btoa(`${this.$store.state.user.user.email}|${this.$store.state.user.user.name}`);
      var url = `${this.$config.api.domain}/#/digests/c${this.docId}?u=${encodedString}`;

      if (this.id.startsWith("c")) {
        url = window.location;
      }
      
      shareTo(url, "Share this digest with your friends.");
    },
    initiateMenu() {
      let menus = [
        { label: "share", icon: "share", disabled: false, emit: "header-command", cmd: "share" },
        { label: "comments", icon: "eye", disabled: false, emit: "header-command", cmd: "comments" },
          { label: "notes", icon: "custom-notes", disabled: false, emit: "header-command", cmd: "notes" },
          { label: "view case", icon: "custom-case", disabled: false, emit: "header-command", cmd: "info" }
        ]

      if(this.$route.query.u) {
      menus.splice(2, 1);
      }

      this.$store.commit("ui/setMoreHeaderButtons", {
        mobile: [
          { icon: "eye", emit: "header-command", cmd: "comments" },
          { icon: "custom-notes", emit: "header-command", cmd: "notes" },
          { icon: "more", emit: "header-command", cmd: "more" }
        ],
        web: menus
      });
      this.$root.$on("header-command", this.onHeaderCommand);
    },
  },

  computed: {
     readingStyle() {
      return [
        "reading-" +
          (this.$store.state.settings.settings.readingMode || "normal"),
        "textsize-" + (this.$store.state.settings.settings.textSize || "normal"),
        "digest-content"
      ];
    },
    rendered() {
      return this.content;
      // return marked(this.content);
    }
  },

  mounted() {
    this.load(this.$store.state.route.params.id);
  },

  beforeDestroy() {
    this.$root.unMountPrintable();
    this.$store.commit("ui/setMoreHeaderButtons", {mobile: [], web: []});
    this.$root.$off("header-command", this.onHeaderCommand);
  },

  components: {
    "popup-menu": Menu,
    Tiptap
  }
};
</script>
<style lang="scss">
@import '@/assets/render.scss';
  .digest-content i {
    color: var(--ion-color-primary);
    font-weight: 500;
    transition: height 0.5s ease-in-out;
    display: block;
    overflow: hidden;
  }

  .digest-title {
    cursor: pointer;
    display: inline-block;
  }

  .digest-title:hover {
    text-decoration: underline;
  }

  .digest-title ion-icon {
    vertical-align: -3px;
  }
  
  .rendered p{
    margin: 0 0 10px;
    text-align: justify;
  }
</style>